// src/pages/designer/DesignerReferrals.jsx — submitted client referrals + showroom status
import React, { useEffect, useState } from "react";
import { useAuth } from "../../hooks/useAuth";
import { getReferralsForDesigner } from "../../lib/db";
import { TableCard, Table, Badge, Spinner, fmt$, fmtDate } from "../../components/UI";

function referralStatusForBadge(status) {
  const s = status || "new";
  const labels = {
    new: "New",
    contacted: "Contacted",
    active: "Active order",
    closed: "Closed",
  };
  return { key: s, label: labels[s] || s };
}

export default function DesignerReferrals() {
  const { profile } = useAuth();
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");

  useEffect(() => {
    if (!profile?.uid) return undefined;
    let cancelled = false;
    setLoadError("");
    setLoading(true);
    getReferralsForDesigner(profile.uid)
      .then((rows) => {
        if (!cancelled) setReferrals(rows);
      })
      .catch((err) => {
        console.error(err);
        if (!cancelled) setLoadError("Could not load referrals.");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [profile?.uid]);

  const cols = [
    { key: "client", label: "Client / Project" },
    { key: "budget", label: "Est. Budget" },
    { key: "desc", label: "Summary" },
    { key: "statusEl", label: "Status" },
    { key: "date", label: "Submitted" },
  ];

  const rows = referrals.map((r) => ({
    client: r.clientName || "—",
    budget: r.budget != null ? fmt$(r.budget) : "—",
    desc: r.description ? (
      <span style={{ fontSize: 12, color: "var(--mid)" }}>{r.description.slice(0, 120)}{r.description.length > 120 ? "…" : ""}</span>
    ) : (
      "—"
    ),
    statusEl: <Badge label={referralStatusForBadge(r.status)} />,
    date: fmtDate(r.createdAt),
  }));

  return (
    <div>
      <div style={{ padding: "36px 48px 0" }}>
        <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 36, fontWeight: 300 }}>My Referrals</h1>
        <p style={{ fontSize: 13, color: "var(--mid)", marginTop: 4 }}>
          Client introductions you submitted through <strong>Client referral</strong>. Status is updated by the showroom (e.g. Active order when a sale is in progress).
        </p>
      </div>
      <div style={{ padding: "24px 48px 48px" }}>
        <TableCard title={`Referrals (${loading ? "…" : referrals.length})`}>
          {loading ? (
            <Spinner />
          ) : loadError ? (
            <div style={{ padding: "36px 24px", fontSize: 14, color: "var(--mid)", textAlign: "center" }}>{loadError}</div>
          ) : (
            <Table cols={cols} rows={rows} emptyMsg="No referrals yet — submit one from Client referral." />
          )}
        </TableCard>
      </div>
    </div>
  );
}
